import { requestConfig } from "../config.js";

/**
 * Проверить по номеру телефона наличие ЭДО у контрагента
 *
 * @param {String} phoneNumber
 */
export default async function apiCheckEdo(phoneNumber) {
  const response = await requestConfig.post("/api/v0/master/mobile_connect/check_edo/", {
    phone: phoneNumber,
  });

  if (!response?.data) throw new Error("Unable to check edo");

  const { key, has_edo } = response.data.detail;
  return {
    key: key,
    hasEdo: has_edo,
  };
}
